import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { useIntl } from '@grandvisionhq/state';
import { aabFAQClickEvent } from '../../data-layer/actions.js';
import useDataLayerInput from '../../hooks/use-data-layer-input.js';
import { usePageData } from '../../pages/BookAppointment/context/PageDataContext.js';
import AppointmentFaq from './AppointmentFaq.js';

const AppointmentFaqContainer = ()=>{
    var ref;
    const [isFaqOpen, setIsFaqOpen] = React.useState(false);
    const { getLabel  } = useIntl();
    const { appointmentFaq  } = usePageData();
    const dataLayerInput = useDataLayerInput();
    const onClickHandler = ()=>{
        DataLayer.pushEvent(aabFAQClickEvent(dataLayerInput));
        setIsFaqOpen(true);
    };
    const onCloseModal = ()=>setIsFaqOpen(false)
    ;
    if (!(appointmentFaq === null || appointmentFaq === void 0 ? void 0 : appointmentFaq.faqItems) || (appointmentFaq === null || appointmentFaq === void 0 ? void 0 : (ref = appointmentFaq.faqItems) === null || ref === void 0 ? void 0 : ref.length) === 0) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "appointment-faq__container"
    }, /*#__PURE__*/ React.createElement("button", {
        type: "button",
        onClick: onClickHandler,
        className: "appointment-faq__button"
    }, /*#__PURE__*/ React.createElement("span", null, getLabel('appointments.component.appointmentTypes.faq'))), /*#__PURE__*/ React.createElement(AppointmentFaq, swcHelpers.extends({}, appointmentFaq, {
        isOpen: isFaqOpen,
        onModalClose: onCloseModal
    })));
};

export { AppointmentFaqContainer as default };
//# sourceMappingURL=AppointmentFaqContainer.js.map
